import UAParser from 'ua-parser-js';

export interface IbrowserInfo {
  name: string;
  version: string;
  osName: string;
}

export const getBrowserInfo = (userAgent: string = navigator.userAgent) => {
  const parser = new UAParser(userAgent);
  const browser = parser.getBrowser();
  const os = parser.getOS();
  return {
    name: browser.name,
    version: browser.version,
    osName: os.name,
  } as IbrowserInfo;
};
